import React, { useState } from 'react'
import Button from 'components/Button'
import { styles } from './styles.scss'

function WithdrawViewForm(props) {
    return(
      <div className={styles}>
        <form>
          <div className="section">
            <div id="pools-form-container" className="box">
              <h3>Withdraw Liquidity</h3>
              <form id="withdraw-liquidity-form">
                <div className="section">
                  <Button
                    id="withdraw-liquidity-button"
                    color="primary"
                    onClick={props.onClick}
                    variant="contained"
                  >
                    Withdraw
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </form>
      </div>
    )
}
export default WithdrawViewForm
